var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== '404')?[(_vm.$store.getters.isPc)?_c('Header'):_vm._e(),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),(_vm.$store.getters.isPc)?_c('Footer'):_vm._e()]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }